import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, DatePicker, Col, TimePicker, Select, Cascader, InputNumber } from 'antd';
// import { text_mk } from '../common/UBCtlMaker';
const FormItem = Form.Item;

class SgiMainComp extends React.Component {

    constructor(props) {
        super(props);
        // var bdInst = this.props.moduleDesc.bdInst;
        this.state = {};
        // if (bdInst) {
        //     this.state[bdInst] = {};
        // }
    }

    //根据描述组装子对象
    createSonComp = function(){


        tool.sgiLogger.log(22222222222222222222);

        //获取当前需要打开的页面信息
        let routerState = this.props.location.state;
        let uid = routerState.uid;


        //临时数据 测试用 后期获取uid属性
        var field1 = {addonBefore: "前置1", addonAfter: "后置1", defaultValue: "", disabled: false, placeholder: "提示1",width:200};
        var field2 = {addonBefore: "前置2", addonAfter: "后置2", defaultValue: "", disabled: false, placeholder: "提示2",width:200};
        var fieldArray = [];
        var fromArray = [];
        if (uid == 'router1'){
            // fieldArray.push(text_mk({}, field1));
            fromArray.push(<Form><h1>我是Form1</h1>{fieldArray}</Form>);
        } else if(uid == 'router2'){
            // fromArray.push(<Form><h1>我是Form1</h1>{text_mk({}, field1)}{text_mk({}, field2)}</Form>);
        } else if(uid == 'router3'){
            // fromArray.push(<Form><h1>我是Form1</h1>{text_mk({}, field1)}</Form>);
            // fromArray.push(<Form><h1>我是Form2</h1>{text_mk({}, field1)}</Form>);
        }      
        return fromArray;
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        var sonComp = this.createSonComp();
        return (
            <div><h1>我是主MKMain</h1>{sonComp}</div>
        );
    }

    //render之前调用，业务逻辑都应该放在这里，如对state的操作等
    componentWillMount = function () {
        tool.sgiLogger.log("componentWillMount");
    }

    //该方法发生在render方法之后。在该方法中，ReactJS会使用render生成返回的虚拟DOM对象来创建真实的DOM结构
    componentDidMount = function () {
        tool.sgiLogger.log("componentDidMount");
    }

    //3.更新阶段
    componentWillReceiveProps = function () {
        tool.sgiLogger.log("componentWillReceiveProps");
    }

    //是否需要更新
    shouldComponentUpdate = function () {
        tool.sgiLogger.log("shouldComponentUpdate");
        return true;
    }

    //将要更新
    componentWillUpdate = function () {
        tool.sgiLogger.log("componentWillUpdate");
    }

    //更新完毕
    componentDidUpdate = function () {
        tool.sgiLogger.log("componentDidUpdate");
    }

    //4.销毁阶段
    componentWillUnmount = function () {
        tool.sgiLogger.log("componentWillUnmount");
    }
}


export { SgiMainComp };
export default SgiMainComp;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiMainCompDemo.js